import { render } from "./ArrowUp.vue.js?vue&type=template&id=94c28324!=!../vue-loader/dist/index.js??ruleSet[0]!./ArrowUp.vue?vue&type=template&id=94c28324"
import script from "./ArrowUp.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./ArrowUp.vue?vue&type=script&lang=js"
export * from "./ArrowUp.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./ArrowUp.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__